import { EventAction } from '@/types/Event.type'

export function getAllEventActions(state: any): Array<EventAction> {
    const physicalActions = state.eventActions?.event?.actions || []
    const streamActions = state.eventActions?.stream?.actions || []

    return [...physicalActions, ...streamActions]
}
